import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
    searchByJob
} from "api/menu/file-manager/actions";

class SearchBar extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);

        this.state = {
            searchValue: ""
        };
    }

    handleChange = (ev) => {
        this.setState({
            searchValue: ev.target.value
        });
    };

    handleSearch = () => {
        this.props.searchByJob(this.state.searchValue);
    };

    render() {
        const {
            searchValue
        } = this.state;

        return (
            <div className="row form-inline p-2 bg-info">
                <div className="form-group mr-4">
                    <label className="mr-2 text-light">Job:</label>
                    <input
                        type="text"
                        className="form-control"
                        value={searchValue}
                        onChange={this.handleChange}
                    />
                </div>
                <div className="form-group mr-4">
                    <button
                        className="btn btn-warning"
                        onClick={this.handleSearch}
                    >
                        Search
                    </button>
                </div>
                <div className="form-group mr-4">
                    <button
                        className="btn btn-danger"
                        onClick={() => { this.setState({ searchValue: "" }, this.handleSearch); }}
                    >
                        Reset
                    </button>
                </div>
            </div>
        );
    }
}

const mapStateToDispatch = dispatch => ({
    searchByJob: bindActionCreators(searchByJob, dispatch)
});

export default connect(
    null,
    mapStateToDispatch
)(SearchBar);
